import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { GetLinkOperationStatus } from 'actions';

import LinkWhsOperationStatus from 'components/LinkWhsOperationStatus';

const LinkWhsOperationMonitor = ({
  dispatch,
  accountId,
  showMonitorExplanation,
  accountWhsLinkStatus,
  reloadOnComplete,
  accountWhsLinkMonitorFailed
}) => {
  const getStatus = async () => {
    dispatch(GetLinkOperationStatus(accountId, reloadOnComplete));
  };

  useEffect(() => {
    if (accountWhsLinkMonitorFailed) {
      return false;
    }
    const interval = setInterval(() => {
      getStatus();
    }, 5000);

    return () => clearInterval(interval);
  }, [getStatus, accountWhsLinkMonitorFailed]);

  return <LinkWhsOperationStatus
    accountWhsLinkStatus={ accountWhsLinkStatus }
    showExplanation={ showMonitorExplanation }
    accountWhsLinkMonitorFailed={ accountWhsLinkMonitorFailed }
  />;
};

LinkWhsOperationMonitor.propTypes = {
  dispatch: PropTypes.func.isRequired,
  accountId: PropTypes.number,
  showMonitorExplanation: PropTypes.bool,
  accountWhsLinkStatus: PropTypes.shape(),
  reloadOnComplete: PropTypes.bool,
  accountWhsLinkMonitorFailed: PropTypes.bool
};

LinkWhsOperationMonitor.defaultProps = {
  accountId: null,
  showMonitorExplanation: true,
  accountWhsLinkStatus: null,
  reloadOnComplete: false,
  accountWhsLinkMonitorFailed: false
};

function mapStateToProps(state) {
  const {
    account: {
      accountWhsLinkStatus,
      accountWhsLinkMonitorFailed
    }
  } = state;

  return {
    accountWhsLinkStatus,
    accountWhsLinkMonitorFailed
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(LinkWhsOperationMonitor);
